@if (loaderIcon | async) {
<app-loader></app-loader>
}
<div class="border p-3 rounded shadow-sm mb-2">
    <div class="row g-2 align-items-center">
        <div class="col-lg-5">
            <div class="row">
                <div class="col-6">
                    <p class="mb-1"><strong>{{'Vendor ID : ' | wordReplace}}</strong>{{vendorInfo?.MarketVendorId}}</p>
                    <p class="mb-1"><strong>Name :</strong> {{vendorInfo?.VendorName}}</p>
                </div>
                <div class="col-6">
                    <p class="mb-1"><strong>Phone :</strong> {{vendorInfo?.Telephone | phoneFormat}}</p>
                    <p class="mb-1"><strong>Email :</strong> {{vendorInfo?.Email}}</p>
                </div>
            </div>
        </div>
        <div class="col-lg-7 d-flex align-items-center gap-2"></div>
    </div>
</div>
<ejs-grid #gridContracts [dataSource]="gridData" height="250" [allowFiltering]="true" (created)="created($event)">
    <e-columns>
        <e-column field="MarketAccountReceiptId" headerText="Contract #" width="120"></e-column>
        <e-column field="BillDate" headerText="Contract Date" width="150" type="date" format="MM/dd/yyyy"></e-column>
        <e-column field="RentalType" headerText="Rental Type" width="150"></e-column>
        <e-column field="print" headerText="Print" textAlign="Center" width="100">
            <ng-template #template let-data>
                <a (click)="onPrint(data)"><img src="./assets/images/print.svg" class="img-fluid" /></a>
            </ng-template>
        </e-column>
        <e-column field="email" headerText="Email" textAlign="Center" width="100">
            <ng-template #template let-data>
                <a (click)="onEmail(data)"><img src="./assets/images/email.svg" class="img-fluid" /></a>
            </ng-template>
        </e-column>
        <e-column field="view" headerText="View" textAlign="Center" width="100">
            <ng-template #template let-data>
                <a (click)="onView(data)"><img src="./assets/images/view.svg" class="img-fluid" /></a>
            </ng-template>
        </e-column>
    </e-columns>
</ejs-grid>
<!-- PDF Preview Modal -->
<div class="modal fade" id="viewContractModal" tabindex="-1" aria-labelledby="viewContractModalLabel"
    aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-xl modal-fullSize">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="viewContractModalLabel">Preview</h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
                <iframe *ngIf="pdfUrl" [src]="pdfUrl" width="100%" height="500px" frameborder="0"></iframe>
            </div>
            <div class="modal-footer">
                <button class="btn btn-orange" data-bs-dismiss="modal">Close</button>
            </div>
        </div>
    </div>
</div>